import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/films';

interface MediaCardProps {
  work: Work;
  className?: string;
}

export default function MediaCard({ work, className = '' }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className={`group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative w-full overflow-hidden aspect-[2/3] bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} ${work.type === 'movie' ? '电影' : '电视剧'}剧情介绍`}
          className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-full bg-accent-500 px-2 py-0.5 text-xs font-semibold text-background-50">
          <i className="ri-star-fill text-xs" />
          {work.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-full bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50">
          {work.type === 'movie' ? '电影' : '剧集'}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate font-heading text-sm font-semibold text-foreground-950 group-hover:text-primary-600 md:text-base">
          {work.title}
        </h3>
        <p className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
          <span>{work.year}</span>
          <span className="h-0.5 w-0.5 rounded-full bg-foreground-400" />
          <span className="truncate">{work.region}</span>
        </p>
        <div className="mt-2 flex flex-wrap gap-1">
          {work.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {g}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}